var map = {
	"./BAT-logo.png": 357,
	"./BUSD-logo.png": 358,
	"./COMP-logo.png": 359,
	"./CRV-logo.png": 360,
	"./DAI-logo.png": 361,
	"./ETH-logo.png": 362,
	"./FTM-logo.png": 363,
	"./KNC-logo.png": 364,
	"./LEND-logo.png": 365,
	"./LINK-logo.png": 366,
	"./MANA-logo.png": 367,
	"./MKR-logo.png": 368,
	"./REP-logo.png": 369,
	"./SAI-logo.png": 370,
	"./SNX-logo.png": 371,
	"./SUSD-logo.png": 372,
	"./TUSD-logo.png": 235,
	"./USDC-logo.png": 373,
	"./USDT-logo.png": 374,
	"./YFI-logo.png": 375,
	"./ZRX-logo.png": 376,
	"./aLINK-logo.png": 377,
	"./cUSDC-logo.png": 378,
	"./cUSDT-logo.png": 379,
	"./iDAI-logo.png": 380,
	"./wBTC-logo.png": 381,
	"./yCRV-logo.png": 382,
	"./ycUSDC-logo.png": 383,
	"./ycUSDT-logo.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;